import { COMPONENT_COLOR_THEMES, COMPONENT_VALUE_TYPES as types } from 'shared/constants';

const propsSchema = [
  {
    key: 'items',
    label: 'Feature Blocks',
    type: types.ARRAY,
    options: {
      maxLength: 4,
    },
    children: [
      {
        key: 'image',
        label: 'Image',
        type: types.S3_ASSET_URL,
        options: {
          cropEnabled: true,
        },
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
        options: {
          maxLength: 50,
        },
      },
      {
        key: 'description',
        label: 'Description',
        type: types.TEXTAREA,
        options: {
          maxLength: 200,
        },
      },
      {
        key: 'link',
        label: 'Link',
        type: types.OBJECT,
        children: [
          {
            key: 'url',
            label: 'Url',
            type: types.TEXT,
          },
          {
            key: 'label',
            label: 'Label',
            type: types.TEXT,
            options: {
              maxLength: 30,
            },
          },
        ],
      },
    ],
  },
  {
    key: 'title',
    label: 'Title (Optional)',
    type: types.TEXT,
    options: {
      maxLength: 75,
    },
  },
  {
    key: 'colorTheme',
    label: 'Theme (text color only)',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES,
  },
];

const defaultProps = {
  items: [
    {
      image: 'https://genesis-cdn.ff.com/faraday-future-gallery/ff-91-interior/FF91_PRESTON_009.jpg',
      title: 'Take a demo drive',
      description: 'Redefining how users interact with companies to generate higher efficiency, higher value, and bridging users to EV industry.',
      link: {
        label: 'Take a demo drive',
        url: '/us/event/demo-drive',
      },
    },
    {
      image: 'https://genesis-cdn.ff.com/press_room/220516_Int_01c_flat-default.jpg',
      title: 'Show Room opening',
      description: 'Redefining how users interact with companies to generate higher efficiency, higher value, and bridging users to EV industry.',
      link: {
        label: 'Learn More',
        url: 'https://www.ff.com/us/press-room/FF-announces-its-first-flagship-brand-experience-center-in-beverly-hills/',
      },
    },
    {
      image: 'https://genesis-cdn.ff.com/assets/pages/co-creation/event-919-futurist-day-default.jpg',
      title: 'Co-Create with us',
      description: 'Redefining how users interact with companies to generate higher efficiency, higher value, and bridging users to EV industry.',
      link: {
        label: 'Become a member',
        url: '/us/co-creation',
      },
    },
  ],
  title: 'Explore Techluxury',
  colorTheme: 'LIGHT',
};

export default {
  title: 'Feature Blocks',
  id: 'FeatureBlocks',
  propsSchema,
  defaultProps,
};
